import { Box, CircularProgress, Toolbar, Typography } from "@mui/material"
import Header from "../layouts/simple/header"

const AuthorizingScreen = () => {
  return (
    <>
      <Header />
      <Toolbar />
      <Box
        sx={{
          minHeight: "calc(100vh - 64px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "grey.50",
          px: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 1.5,
            px: 4,
            py: 3.5,
            borderRadius: 2,
            bgcolor: "background.paper",
            boxShadow: 3,
            maxWidth: 360,
          }}
        >
          <CircularProgress size={36} />
          <Typography variant="h6" fontWeight={600}>
            Authorizing
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we verify your credentials.
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default AuthorizingScreen
